// ProfileDropdown: Professional dropdown for profile options
import React, { useState, useEffect } from 'react';
import { IconButton, Menu, MenuItem, ListItemText, Avatar, Divider, Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';




function ProfileDropdown() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutDialog, setLogoutDialog] = useState(false);
  const { profile: serverProfile } = useProfile() || {};
  const [profile, setProfile] = useState(serverProfile || {});
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  useEffect(() => {
    // If server profile is available, use it; otherwise fallback to localStorage
    if (serverProfile) {
      setProfile(serverProfile);
      try { localStorage.setItem('user', JSON.stringify(serverProfile)); } catch (e) {}
      return;
    }
    try {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      // normalize id key
      if (user._id && !user.id) user.id = user._id;
      // normalize role into a primary role string for display and sidebar logic
      const normalizeRoles = (r) => {
        if (!r) return [];
        if (Array.isArray(r)) return r.map(x => String(x).trim().toLowerCase()).filter(Boolean);
        if (typeof r === 'string') return r.split(/[,;|]/).map(x => String(x).trim().toLowerCase()).filter(Boolean);
        return [String(r).trim().toLowerCase()];
      };
      const pickPrimaryRole = (rolesArr) => {
        const order = ['superadmin', 'admin', 'staff'];
        for (const p of order) if (rolesArr.includes(p)) return p;
        return rolesArr[0] || '';
      };
      const roles = normalizeRoles(user.role);
      const primary = pickPrimaryRole(roles);
      if (primary) user.role = primary;
      // persist normalized user for other components
      try { localStorage.setItem('user', JSON.stringify(user)); } catch (e) {}
      setProfile(user);
    } catch (e) {
      setProfile({});
    }
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleProfile = () => {
    handleClose();
    navigate('/profile');
  };
  const handleLogout = () => {
    handleClose();
    setLogoutDialog(true);
  };
  const confirmLogout = () => {
    setLogoutDialog(false);
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Avatar>
          <AccountCircle />
        </Avatar>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold">{profile.name || 'User'}</Typography>
          <Typography variant="body2">{profile.email}</Typography>
          <Typography variant="caption">Role: {profile.role}</Typography>
          <Typography variant="caption">ID: {profile.id || profile._id}</Typography>
        </Box>
        <Divider />
        <MenuItem onClick={handleProfile}><ListItemText primary="Profile" /></MenuItem>
        {/* Navigation belongs in the sidebar; keep dropdown for profile actions only */}
        <MenuItem onClick={handleLogout}><ListItemText primary="Log Out" /></MenuItem>
      </Menu>
      <Dialog open={logoutDialog} onClose={() => setLogoutDialog(false)}>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to log out?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutDialog(false)}>Cancel</Button>
          <Button onClick={confirmLogout} color="error" variant="contained">Log Out</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ProfileDropdown;
